import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Lang = ({className})=> {
   
 

    //=>DEFAULT no need to create setitem => its done with pluging i18next-browser-languagedetector , const currentLang = localStorage.getItem('i18nextLng') || 'en';

  const { t, i18n } = useTranslation();
  const switchLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
    return (
      <>
        {/* Flag */}
        <li className={`nav-item dropdown has-arrow flag-nav d-flex align-items-center ${className || ''}`}>
          <Link
            className="nav-link dropdown-toggle d-flex align-items-center justify-content-center"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
          >

            {
              i18n.language === "en" && <>
               <span className="fi fi-gb flag-selected"></span> 
                <span>English</span>
              </>
            }

            {
              i18n.language === "id" && <>
                 <span className="fi fi-id flag-selected"></span> 
                <span>Indonesian</span>
              </>}
             
              {
              i18n.language === "tgl" && <>
                 <span className="fi fi-ph flag-selected"></span> 
                <span>Tagalog</span>
              </>}
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <button onClick={() => {
              switchLanguage('en');
              
            }} className="dropdown-item">
             <span className="fi fi-gb flag-selected"></span> 
              <span>English</span>
            </button>
            <button onClick={() => {
              switchLanguage('id');
    
            }} className="dropdown-item">
              <span className="fi fi-id flag-selected"></span> 
              <span>Indonesian</span>
            </button>
            <button onClick={() => {
              switchLanguage('tgl');
    
            }} className="dropdown-item">
              <span className="fi fi-ph flag-selected"></span> 
              <span>Tagalog</span>
            </button>

          </div>
        </li>
        </>

    )
}
Lang.propTypes = {
  className: PropTypes.object
}
export default Lang;